import { getRandomId } from '../../helpers/helpers';
/**
 * Manage subscriptions easily with one class.  For any subscription created pass it to setSubscription.
 * And simply call unsubscribe all in the component did unmount function.
 */
export class SubManager {
    constructor() {
        /** Map of subscriptions for the class */
        this.subscriptions = new Map();
    }
    /**
     * Check passed subscription and if possible unsubscribe from it.
     *
     * @param sub - a subscription to test and unsubscribe from if possible
     */
    safeUnsubscribe(sub) {
        if (sub && typeof sub.unsubscribe === 'function') {
            sub.unsubscribe();
        }
    }
    /**
     * Generate a fake key for storing in the map
     *
     * @returns fake key
     */
    getFakeKey() {
        return `key-${getRandomId()}`;
    }
    /**
     * For any subscription created set it here to easily unsubscribe all
     *
     * @param subscription - subscription to store in the manager
     * @param key - key to use for manual unsubscribing (if needed)
     *
     * @returns a key that is being used for internal storage
     */
    setSubscription(subscription, key) {
        const keyToUse = key || this.getFakeKey();
        this.subscriptions.set(keyToUse, subscription);
        return keyToUse;
    }
    /**
     * Retrieve prior subscription set
     *
     * @param key - key to use for manual unsubscribing (if needed)
     *
     * @returns subscription that goes with the key if found
     */
    getSubscription(key) {
        return this.subscriptions.get(key);
    }
    /**
     * Retrieve all subscriptions set
     *
     * @returns array of subscriptions
     */
    getAllSubscription() {
        const subs = [];
        this.subscriptions.forEach(sub => subs.push(sub));
        return subs;
    }
    /**
     * Unsubscribe from a specific subscription
     *
     * @param key - key used for referencing a subscription
     */
    unsubscribe(key) {
        this.safeUnsubscribe(this.subscriptions.get(key));
        this.subscriptions.delete(key);
    }
    /**
     * Unsubscribe from all subscriptions in the sub manager
     * Most commonly used in `componentWillUnmount`
     */
    unsubscribeAll() {
        this.subscriptions.forEach(sub => {
            this.safeUnsubscribe(sub);
        });
        this.subscriptions.clear();
    }
}
